export const objConstants = {
      
    ADD_REQUEST: 'OBJ_ADD_REQUEST',
    ADD_SUCCESS: 'OBJ_ADD_SUCCESS',
    ADD_FAILURE: 'OBJ_ADD_FAILURE',

    UPDATE_REQUEST: 'OBJ_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'OBJ_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'OBJ_UPDATE_FAILURE',
  
    GETALL_REQUEST: 'OBJ_GETALL_REQUEST',
    GETALL_SUCCESS: 'OBJ_GETALL_SUCCESS',
    GETALL_FAILURE: 'OBJ_GETALL_FAILURE',
    
    GET_REQUEST: 'OBJ_GET_REQUEST',
    GET_SUCCESS: 'OBJ_GET_SUCCESS',
    GET_FAILURE: 'OBJ_GET_FAILURE',

    DELETE_REQUEST: 'OBJ_DELETE_REQUEST',
    DELETE_SUCCESS: 'OBJ_DELETE_SUCCESS',
    DELETE_FAILURE: 'OBJ_DELETE_FAILURE'    
};
